import Vue from 'vue'
import '../v-video/v-video.vue'
import '../picture/picture.vue'

Vue.component('hero-short', {
  name: 'HeroShort',
  props: {
    title: {
      type: String,
      default: '',
    },
    videoUrlMobile: {
      type: String,
      default: '',
    },
    videoUrlDesktop: {
      type: String,
      default: '',
    },
    videoSubtitles: {
      type: String,
      default: null,
    },
    autoPlayVideo: {
      type: Boolean,
      default: false,
    },
    imageMobile: {
      type: String,
      default: '',
    },
    imageDesktop: {
      type: String,
      default: '',
    },
    lightText: {
      type: Boolean,
      default: false,
    },
    lightNavText: {
      type: Boolean,
      default: false,
    },
    showVideoVolumeButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    videoUrls() {
      const videoUrls = []
      if (this.videoUrlMobile) videoUrls.push(this.videoUrlMobile)
      if (this.videoUrlDesktop) videoUrls.push(this.videoUrlDesktop)
      return videoUrls
    },
  },
  mounted() {
    if (this.lightNavText) {
      document.body.classList.add('nav-white')
    }

    setTimeout(() => {
      window.scrollAnimations.update()
    }, 0)
  },
})